export const CustomRepetitionIntervalType = {
    WEEK: "CustomRepetitionIntervalType.WEEK",
    MONTH: "CustomRepetitionIntervalType.MONTH"
};
